import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { LessonPrint } from "@shared/models/analytics/lesson"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"
import defaultLessonContext from "../lesson/default-lesson-context"
import defaultLessonModels from "../lesson/default-lesson-models"

interface Payload {
  cardStackId: string
  perspective: "day" | "week" | "month" | "timeline" | "standards_tracker"
}

export default function printCardStackAction(payload: Payload): PreparedAction {
  return {
    name: "PRINT_CARD_STACK",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let models = defaultLessonModels(payload, findFn, userId)
  let context = defaultLessonContext(payload, models)
  let titleForAnalytics =
    payload.perspective === "timeline" ? "Lesson Print - Unit" : "Lesson Print"

  let newEvent: LessonPrint = {
    ...createBlankEvent(),
    root_id: models.planbook?.id ?? null,
    root_type: "planbook",
    date_plan_scheduled_for: models.dateStringForCardStack,
    primary_verb: "print",
    primary_possessive: "owns",

    primary_object_type: "lesson",
    primary_object_id: payload.cardStackId,
    primary_object_specifier: null,
    primary_object_id_and_ancestor_ids: models.cardStackIdAndAncestorIds,

    adverbial_verb: null,
    adverbial_possessive: null,

    adverbial_object_type: payload.perspective === "timeline" ? "unit" : null,
    adverbial_object_id: payload.cardStackId,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: models.cardStackIdAndAncestorIds,
  }

  return createNarrative({
    title: `Lesson Printed`,
    titleForAnalytics: titleForAnalytics,
    description: `Printing from the ${payload.perspective}`,
    context: context,
    newAnalyticsEvents: [newEvent],
  })
}
